export type BrowserCameraPermissionState = 'granted' | 'denied' | 'prompt'

export interface CameraDiagnostics {
  browserPermissionState: BrowserCameraPermissionState | null,
  videoInputCount: number | null,
}

export const EMPTY_CAMERA_DIAGNOSTICS: CameraDiagnostics = { browserPermissionState: null, videoInputCount: null }

async function queryPermissionState (): Promise<BrowserCameraPermissionState | null> {
  try {
    const status = await navigator.permissions.query({ name: 'camera' as PermissionName })
    return status.state === 'granted' || status.state === 'denied' || status.state === 'prompt'
      ? status.state
      : null
  } catch (_) {
    return null
  }
}

async function countVideoInputs (): Promise<number | null> {
  try {
    const devices = await navigator.mediaDevices.enumerateDevices()
    return devices.filter(device => device.kind === 'videoinput').length
  } catch (_) {
    return null
  }
}

export async function getCameraDiagnostics (): Promise<CameraDiagnostics> {
  if (typeof navigator === 'undefined') {
    return EMPTY_CAMERA_DIAGNOSTICS
  }

  const [browserPermissionState, videoInputCount] = await Promise.all([
    queryPermissionState(),
    countVideoInputs(),
  ])

  return { browserPermissionState, videoInputCount }
}
